import React from 'react';
import {Icon, ListItem, ListItemText} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {NavLinkAdapter, FuseUtils} from '@fuse';
import {withRouter} from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector} from 'react-redux';
import * as Actions from 'app/store/actions';
import FuseNavBadge from './../FuseNavBadge';
import { buttonBgColor, buttonBgHoverColor, buttonTextHoverColor } from 'styles/BasicStyles';

const useStyles = makeStyles(theme => ({
    item: {
        height                     : 40,
        width                      : '100%',
        paddingRight               : 12,
        '&.active'                 : {
            backgroundColor            : buttonBgColor,
            color                      : theme.palette.secondary.contrastText + '!important',
            pointerEvents              : 'none',
            transition                 : 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
            '& .list-item-text-primary': {
                color: 'inherit'
            },
            '& .list-item-icon'        : {
                color: 'inherit'
            }
        },
        '&:hover': {
            backgroundColor: buttonBgHoverColor,
            color: buttonTextHoverColor,
            '& .list-item-icon'        : {
                color: buttonTextHoverColor
            },
        },
        '&.square, &.active.square': {
            width       : '100%',
            borderRadius: '0'
        },
        '& .list-item-icon'        : {},
        '& .list-item-text'        : {
            letterSpacing: '2px',
            textTransform: 'uppercase'
        },
        color                      : theme.palette.text.primary,
        cursor                     : 'pointer',
        textDecoration             : 'none!important',
        '& .list-item-text-primary': {
            fontWeight: 'bold',
        },
    }
}));

function FuseNavVerticalItem(props)
{
    const dispatch = useDispatch();
    const { userRole, fuseSettings, hasTeacher } = useSelector(({ base, fuse, student }) => ({
        userRole: base.auth.role,
        hasTeacher: !!(student && student.teacher),
        fuseSettings: fuse.settings
    }));

    const classes = useStyles(props);
    const {item, nestedLevel, active, location} = props;
    let paddingValue = 40 + (nestedLevel * 16);
    const listItemPadding = nestedLevel > 0 ? 'pl-' + (paddingValue > 80 ? 80 : paddingValue) : 'pl-24';

    if ( !FuseUtils.hasPermission(item.auth, userRole) || item.teacherRequired && !hasTeacher )
    {
        return null;
    }

    function getItemIcon(icon, active) {
        if (!icon) {
            return null
        }

        const className = 'list-item-icon text-16 flex-shrink-0 mr-16'
        if (typeof icon === 'string') {
            return <Icon color="action" className={className}>{icon}</Icon>
        }
        else {
            const ItemIcon = icon
            // use action color specified in current fuse theme
            const color = !active ? fuseSettings.navbarTheme.palette.action.active : fuseSettings.navbarTheme.palette.common.white
            return <ItemIcon className={`${className} w-16 h-16`} color={color} />
        }
    }

    const className = clsx(classes.item, listItemPadding, 'list-item', active);
    return (
        <ListItem
            button
            component={NavLinkAdapter}
            to={item.url}
            activeClassName="active"
            className={className}
            onClick={ev => dispatch(Actions.navbarCloseMobile())}
            exact={item.exact}
        >
            {item.icon && getItemIcon(item.icon, !!location.pathname && location.pathname.includes(item.url))}
            <ListItemText className="list-item-text" primary={item.title} classes={{primary: 'text-14 list-item-text-primary'}}/>
            {item.badge && (
                <FuseNavBadge badge={item.badge}/>
            )}
        </ListItem>
    );
}

FuseNavVerticalItem.propTypes = {
    item: PropTypes.shape(
        {
            id   : PropTypes.string.isRequired,
            title: PropTypes.string,
            icon : PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
            url  : PropTypes.string
        })
};

FuseNavVerticalItem.defaultProps = {};

const NavVerticalItem = withRouter(React.memo(FuseNavVerticalItem));

export default NavVerticalItem;
